import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import delay from 'lodash/delay';
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import { TIMER } from '~/const/timers';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/loupe.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/micro.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import pageActions from '~/store/modules/pageActions';
import registerStoreModule from '~/helpers/store-helper';

var SearchResults = () => import('./SearchResults.vue');

var LayerFullscreen = () => import(
/* webpackChunkName: "layer" */
'~/components/specific/MainHeader/LayerFullscreen.vue');

var AlgoliaSearch = () => import('~/components/organisms/Category/AlgoliaSearch.vue');

export default {
  name: 'SearchItem',
  components: {
    SearchResults,
    LayerFullscreen
  },
  props: {
    hasStickedFilters: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      algoliaSearchComponent: null,
      algoliaSearch: null,
      isOpenMenu: false,
      searchError: false,
      search: '',
      results: {
        products: [],
        total: 0
      },
      loading: false,
      searchResults: true
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    formAction() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/q/").concat(this.sanitizedSearch);
    },

    sanitizedSearch() {
      return this.search ? this.search.trim().replace(/[()<>[\]{}"/\\;=?.]/gi, '') : '';
    },

    totalResults() {
      return this.results.total;
    }

  }),
  watch: {
    search() {
      this.debounceGetSuggestion();
    },

    value() {
      if (this.type === 'search' && this.value === true && this.$refs.search !== undefined) {
        this.focus();
      }

      if (this.type === 'search' && !this.value) {
        this.resetForm();
      }
    }

  },

  created() {
    registerStoreModule(this.$store, 'pageActions/', pageActions);
  },

  mounted() {
    this.$root.$on('open-algolia-search', () => {
      this.openSearch();
    });
    this.$root.$on('close-algolia-search', () => {
      this.closeSearch(true);
    });
    this.$root.$on('close-search-results', () => {
      this.searchResults = false;
    });
  },

  destroyed() {
    this.$root.$off('close-search-results');
  },

  methods: {
    openSearch() {
      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';
      var tracking = {
        data: {
          event_category: 'Header',
          event_action: 'Search',
          event_label: 'ES_Clic'
        }
      };

      if (this.algoliaSearch) {
        this.isOpenMenu = true;
        this.algoliaSearchComponent = AlgoliaSearch;
        tracking = {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Clic'
          }
        };
      }

      this.$root.$emit('generic-tracking', null, tracking);
    },

    closeSearch() {
      var productClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isOpenMenu = false;
      this.resetForm();
      var queries = {};
      this.$router.replace({
        query: queries
      });
      this.algoliaSearchComponent = null;

      if (!productClicked) {
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Fermer'
          }
        });
      }

      this.$root.$emit('reset-tcvars');
    },

    debounceGetSuggestion: debounce(function getSuggestions() {
      this.getSuggestions();
    }, 200),

    focusSearchInput() {
      delay(() => this.$refs.search.focus(), 50);
    },

    handleSubmit() {
      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';

      if (this.algoliaSearch) {
        this.openSearch();
      } else {
        if (this.search === '') {
          this.searchError = true;
          delay(() => {
            this.searchError = false;
          }, TIMER);
        }

        this.$router.push(this.formAction);
        this.resetForm();
        this.$refs.search.blur();
        this.$emit('submitCloseMenu');
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'ES_Entrée'
          }
        });
      }
    },

    handleInput(_ref) {
      var {
        target
      } = _ref;
      this.search = target.value;
      this.searchResults = true;
    },

    handleArrowUp() {
      this.$refs.searchResults.focusLastItem();
    },

    handleArrowDown() {
      this.$refs.searchResults.focusFirstItem();
    },

    handleLeaveViewSuggestion() {
      this.$emit('hide-search-banner');
      this.resetForm();
      this.$root.$emit('hide-layer');
    },

    gotToSearch() {
      this.$root.$emit('hide-layer');
      this.$router.push(this.formAction);
      this.resetForm();
    },

    getSuggestions() {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (!_this.sanitizedSearch) {
          _this.resetForm();

          return;
        }

        if (_this.sanitizedSearch.length < 3) {
          return;
        }

        _this.loading = true;

        try {
          var {
            data: {
              categorySearch,
              productSearchSuggest
            }
          } = yield _this.$apolloProvider.defaultClient.query({
            query: searchSuggestionQuery,
            variables: {
              locale: _this.locale.iso,
              keyword: _this.sanitizedSearch,
              offset: 0,
              limit: 5,
              sortBy: 'POPULAR',
              orderBy: 'DEFAULT',
              filterBy: []
            }
          });
          _this.loading = false;
          var {
            products,
            total: totalProducts
          } = productSearchSuggest;
          var categories = categorySearch;
          var total = products.length + categories.length;
          _this.results = {
            query: _this.sanitizedSearch,
            products,
            categories,
            total,
            totalProducts
          };
        } catch (e) {
          _this.loading = false;

          _this.$logger.error(e);
        }
      })();
    },

    resetForm() {
      this.search = '';
      this.searchError = false;
      this.results = {
        products: [],
        total: 0
      };
    },

    updateSearchValue(keyword) {
      this.search = keyword;
    }

  }
};